import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
import { useContext } from 'react';
import { Alert, AlertTitle, Box, Link } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { MainContext } from '../../context';
/**
 * The warning shown wherever an unverified namespace is holding something back — the extension
 * settings page and the namespace settings page share it, so both read the same.
 *
 * The action is the deployment's `elements.claimNamespace` (typically an issue template), falling
 * back to the namespace-access docs. It is a link rather than a button: the theme already styles
 * links inside an alert, so it sits in the notice instead of competing with it.
 */
export const NamespaceClaimNotice = ({ namespace, extension, showAction = false, sx, children }) => {
    const { pageSettings } = useContext(MainContext);
    const ClaimNamespace = pageSettings.elements?.claimNamespace;
    return (_jsxs(Alert, { severity: 'warning', sx: sx, children: [_jsx(AlertTitle, { sx: { fontWeight: 700 }, children: "Namespace not verified" }), children, showAction ? (_jsx(Box, { sx: { mt: '0.75rem' }, children: ClaimNamespace ? (_jsx(ClaimNamespace, { namespace: namespace, extension: extension })) : (
                // Nothing configured for this deployment: point at the generic docs.
                _jsxs(Link, { href: pageSettings.urls.namespaceAccessInfo, target: '_blank', rel: 'noopener', children: ["Claim ownership", _jsx(ArrowForwardIcon, { sx: { fontSize: '1.125rem' } })] })) })) : null] }));
};
//# sourceMappingURL=namespace-claim-notice.js.map